var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.666 30V14.468l7.198 6.762c.672.63 1.725.597 2.354-.075a1.672 1.672 0 00-.075-2.357L20 8.333 8.861 18.797a1.664 1.664 0 102.279 2.432l7.197-6.761V30a1.665 1.665 0 103.33 0z",
    fill: "#0373F9"
  })));
}

export default "data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M21.6662 30.0009L21.6662 14.4675L28.864 21.2292C29.5365 21.8592 30.5886 21.8259 31.2178 21.1542C31.8454 20.4842 31.8121 19.4292 31.1429 18.7975L20.0015 8.33252L8.86017 18.7975C8.51226 19.1275 8.33415 19.5692 8.33415 20.0142C8.33415 20.4225 8.48396 20.8325 8.78526 21.1542C9.41449 21.8259 10.4665 21.8592 11.139 21.2292L18.3369 14.4675L18.3369 30.0009C18.3369 30.9209 19.081 31.6675 20.0015 31.6675C20.9221 31.6675 21.6662 30.9209 21.6662 30.0009Z' fill='%230373F9'/%3E %3C/svg%3E";
export { SvgIcArrow as ReactComponent };